/**
 * The four ways money actually arrives, and they MUST be the four the server
 * accepts - src/lib/constants.ts PAYMENT_METHODS.
 *
 * WHY THIS IS ITS OWN MODULE
 *
 * It lived inside PaymentCollect.tsx until a second screen needed it. Copying
 * it would have been the obvious move and the wrong one, because this exact
 * list has already been wrong twice in ways no typecheck could see - the
 * value crosses the wire as a string:
 *
 *  - "CHECK" is not one of the server's values ("CHEQUE" is), so every cheque
 *    collection was rejected by the API, and by a CHECK constraint behind it;
 *  - UPI was missing altogether, and the receipts book this system was
 *    modelled on says UPI is the single most common mode in it. The most
 *    common way a customer pays could not be recorded at all.
 *
 * Two copies would be two chances to make that mistake again, and the drift
 * test can only be pointed at one of them.
 *
 * test/ui-state-map.test.ts fails if this list and PAYMENT_METHODS drift.
 */
export const METHODS = [
  { value: "CASH", label: "Cash", instrument: null },
  { value: "CHEQUE", label: "Cheque", instrument: "Cheque number" },
  { value: "UPI", label: "UPI", instrument: "UPI reference" },
  { value: "ONLINE", label: "Online transfer", instrument: "Bank UTR" },
] as const;

export type Method = (typeof METHODS)[number]["value"];
